import * as React from 'react';
import { Box, BoxProps } from '@theme-ui/components';
import { inlineAlignMap, blockAlignMap, InlineAlign, BlockAlign } from './layout';

type InheritedProps = Omit<BoxProps, 'ref'>;

export interface InlineProps extends InheritedProps {
  gap?: number | number[] | string | string[];
  reverse?: boolean;
  divider?: string;
  align?: Exclude<InlineAlign, 'top' | 'bottom'>;
  alignY?: Exclude<BlockAlign, 'left' | 'right'>;
  wrap?: boolean;
  childrenBottomMargin?: boolean;
  UNSTABLE_nativeGap?: number | number[] | string | string[];
}

export const Inline = React.forwardRef<HTMLDivElement, InlineProps>(
  (
    {
      gap,
      align,
      alignY,
      divider,
      wrap,
      reverse,
      childrenBottomMargin,
      UNSTABLE_nativeGap,
      ...props
    },
    ref
  ) => {
    return (
      <Box
        ref={ref}
        {...props}
        // @ts-ignore
        __css={{
          display: 'flex',
          justifyContent: align ? inlineAlignMap[align] : undefined,
          alignItems: alignY ? blockAlignMap[alignY] : undefined,
          flexDirection: reverse ? 'row-reverse' : 'row',
          flexWrap: wrap ? 'wrap' : 'nowrap',
          gap: UNSTABLE_nativeGap,
          ...(!childrenBottomMargin && { rowGap: gap }),
          ...(childrenBottomMargin && {
            '> *:last-child, > *:not(:last-child)': {
              mb: gap
            }
          }),
          '> *:not(:last-child)': {
            [reverse ? 'marginLeft' : 'marginRight']: gap,
            ...(divider && {
              ':after': {
                content: `"${divider}"`,
                [reverse ? 'marginRight' : 'marginLeft']: gap
              }
            })
          }
        }}
      />
    );
  }
);
